import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativeHoursBetween32and45FNOV: typeof valueTypeRenderers.chillCumulativeHoursBetween32and45FNOV =
  {
    label: () => unitConverter.chillCumulativeHoursBetween32and45FNOV().title(),
    point: () =>
      makeNumberRenderer({
        baseLabel: unitConverter.chillCumulativeHoursBetween32and45FNOV().title(),
        render: (n) => unitConverter.chillCumulativeHoursBetween32and45FNOV(n).valueAsString(),
      }),
  }
